(function () {
  function initialize(root) {
    root.querySelectorAll('[data-home-campaign-slider]:not([data-slider-ready])').forEach(function (slider) {
      slider.dataset.sliderReady = 'true';

      var slideArea = slider.querySelector('.HomeCampaignSlider__slides');
      var slides = Array.from(slider.querySelectorAll('[data-campaign-slide]'));
      var tabs = Array.from(slider.querySelectorAll('[role="tab"]'));
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var isVisible = true;
      var pointerStart = null;
      var suppressNavigation = false;

      if (!slides.length || slides.length !== tabs.length) {
        return;
      }

      function currentIndex() {
        return tabs.findIndex(function (tab) {
          return tab.getAttribute('aria-selected') === 'true';
        });
      }

      function syncVideos() {
        var isDesktop = window.matchMedia('(min-width: 992px)').matches;

        slides.forEach(function (slide) {
          slide.querySelectorAll('[data-hero-video-variant] video').forEach(function (video) {
            var shouldPlay = slide.classList.contains('is-active') && isVisible && !reducedMotion.matches &&
              video.parentElement.dataset.heroVideoVariant === (isDesktop ? 'desktop' : 'mobile');

            if (!shouldPlay) {
              video.pause();
              return;
            }

            if (video.preload === 'none') {
              video.preload = 'metadata';
              video.load();
            }

            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          });
        });
      }

      function syncAutoplay() {
        var focusedElement = document.activeElement;
        var keyboardFocus = slider.contains(focusedElement) && focusedElement.matches(':focus-visible');
        var paused = reducedMotion.matches || document.hidden || !isVisible ||
          keyboardFocus || Boolean(window.Shopify && window.Shopify.designMode);

        slider.toggleAttribute('data-autoplay-paused', paused);
      }

      function restartProgress() {
        tabs.forEach(function (tab) {
          tab.classList.remove('is-running');
        });

        if (slides.length > 1 && !reducedMotion.matches && !(window.Shopify && window.Shopify.designMode)) {
          var activeTab = tabs[currentIndex()];
          void activeTab.offsetWidth;
          activeTab.classList.add('is-running');
        }
      }

      function select(index, focusTab) {
        if (index < 0 || index >= slides.length) {
          return;
        }

        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
          tabs[slideIndex].classList.toggle('is-active', active);
          tabs[slideIndex].setAttribute('aria-selected', active ? 'true' : 'false');
          tabs[slideIndex].tabIndex = active ? 0 : -1;
        });

        if (focusTab) {
          tabs[index].focus();
        }

        syncAutoplay();
        restartProgress();
        syncVideos();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(tabs.indexOf(tab), false);
        });

        tab.addEventListener('keydown', function (event) {
          var index = tabs.indexOf(tab);
          var nextIndex;
          if (event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          select(nextIndex, true);
        });

        tab.querySelector('.HomeCampaignSlider__progress').addEventListener('animationend', function (event) {
          if (event.animationName === 'campaign-progress' && tabs.indexOf(tab) === currentIndex()) {
            select((tabs.indexOf(tab) + 1) % slides.length, false);
          }
        });
      });

      slideArea.addEventListener('pointerdown', function (event) {
        if (event.isPrimary && (event.pointerType !== 'mouse' || event.button === 0)) {
          pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }
      });

      slideArea.addEventListener('pointerup', function (event) {
        if (!pointerStart || event.pointerId !== pointerStart.id) {
          return;
        }

        var deltaX = event.clientX - pointerStart.x;
        var deltaY = event.clientY - pointerStart.y;
        pointerStart = null;

        if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) {
          return;
        }

        suppressNavigation = true;
        window.setTimeout(function () {
          suppressNavigation = false;
        }, 400);
        select((currentIndex() + (deltaX < 0 ? 1 : -1) + slides.length) % slides.length, false);
      });

      slideArea.addEventListener('pointercancel', function () {
        pointerStart = null;
      });

      slideArea.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      slideArea.addEventListener('click', function (event) {
        if (suppressNavigation && event.target.closest('.HomeCampaignSlider__link')) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      slider.addEventListener('focusin', syncAutoplay);
      slider.addEventListener('focusout', function () {
        window.requestAnimationFrame(syncAutoplay);
      });
      document.addEventListener('visibilitychange', syncAutoplay);
      window.addEventListener('resize', syncVideos);

      function onMotionChange() {
        syncAutoplay();
        restartProgress();
        syncVideos();
      }

      if (typeof reducedMotion.addEventListener === 'function') {
        reducedMotion.addEventListener('change', onMotionChange);
      } else if (typeof reducedMotion.addListener === 'function') {
        reducedMotion.addListener(onMotionChange);
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          isVisible = entries[0].isIntersecting;
          syncAutoplay();
          syncVideos();
        }, { threshold: 0.1 }).observe(slider);
      }

      slider.addEventListener('shopify:block:select', function (event) {
        var selectedSlide = event.target.closest('[data-campaign-slide]');
        var selectedIndex = slides.indexOf(selectedSlide);
        if (selectedIndex >= 0) {
          select(selectedIndex, false);
        }
      });

      function removeExpiredCampaign() {
        var activeSlide = slides[currentIndex()];
        var focused = slider.contains(document.activeElement);
        slides.filter(function (slide) { return slide.dataset.campaignName === 'halloween'; }).forEach(function (slide) {
          var index = slides.indexOf(slide);
          var tab = tabs[index];
          slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
          slide.remove();
          if (tab) tab.remove();
          slides.splice(index, 1);
          tabs.splice(index, 1);
        });
        slider.classList.toggle('HomeCampaignSlider--single', slides.length === 1);
        if (!slides.length) { slider.hidden = true; return; }
        select(Math.max(0, slides.indexOf(activeSlide)), focused && !slider.contains(document.activeElement));
      }
      document.addEventListener('berries:promotion-ended', removeExpiredCampaign);
      if (window.BerriesPromotionEnded) removeExpiredCampaign();

      syncAutoplay();
      restartProgress();
      syncVideos();
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
